import { Component, OnInit, Input, Output, EventEmitter, Optional } from '@angular/core';
import { SearchEngineDataService } from 'src/app/_services/search-engine-data.service';

@Component({
  selector: 'app-topic-info',
  templateUrl: './topic-info.component.html',
  styleUrls: ['./topic-info.component.css']
})
export class TopicInfoComponent implements OnInit {
  @Input() topic: {id:0,name:"", subtopics:[]};
  @Input() myCount:number
  @Output() renderMathRequest = new EventEmitter<boolean>()
  constructor() { }

  ngOnInit(): void {

  }
  ngAfterViewInit(){
      this.renderMathRequest.emit(true)
  }



}
